import { AppStore } from 'components/stores/AppStore';
import { NotificationMessageProps } from "components/props";
import uuid from 'react-uuid';

export const AppNotificationSystemNames = {
    MapAisFetchDataError: 'MapAisFetchDataError',
    MapAisFetchShipDataError: 'MapAisFetchShipDataError',
}

export const AppNotificationService = {

    addNotification(message: NotificationMessageProps) {
        setTimeout(() => {
            AppStore.getState().setNotificationMessage(message);
        }, 5);
    },

    addSuccessNotification(message: string) {
        this.addNotification({
            id: uuid(),
            type: "success",
            text: message,
            fadeout: true,
        });
    },

    addInfoNotification(message: string, fadeout = true) {
        this.addNotification({
            id: uuid(),
            type: "info",
            text: message,
            fadeout: fadeout,
        });
    },

    addWarningNotification(message: string, systemName = "", fadeout = false) {
        this.addNotification({
            id: uuid(),
            type: "warning",
            text: message,
            fadeout: fadeout,
            systemName: systemName
        });
    },

    addErrorNotification(message: string, fadeout = false) {
        this.addNotification({
            id: uuid(),
            type: "error",
            text: message,
            fadeout: fadeout
        });
    }

};
